import {Modal} from "antd";
import {Line, MStack, Text} from "utils";
import {Button} from "ui/FFButton";
import React from "react";
import {WarningIcon} from "icons";
import {toJS} from "mobx";
import cn from "classnames";
import 'components/ModalWindow/style.scss'

interface ModalContentProps {
    title?: string;
    icon?: React.ReactNode;
    children?: React.ReactNode;
    buttons?: React.ReactNode[];
    buttonText?: string;
    onOk?: () => void;
    mobileReverse?: boolean
}


export const ModalContentBasic = ({title, icon, children, buttons, buttonText, onOk, mobileReverse}: ModalContentProps) => {
    let normalizedButtons: React.ReactNode[] | undefined = buttons;
    if (normalizedButtons === undefined && !!buttonText) {
        normalizedButtons = [
            <Button key={'modal-primary-action'} onClick={onOk}>{buttonText}</Button>
        ]
    } else if(!!normalizedButtons) {
        normalizedButtons = normalizedButtons.map(item => toJS(item))
    }
    const isSingleButton = !!normalizedButtons && normalizedButtons.length === 1;
    if (icon === "warning") {
        icon = <div className={'modal-icon warning-icon'}><WarningIcon/></div>
    }
    return <MStack align={'stretch'} gap={24}>
        {
            !!title &&
            <Line gap={16} center>
                {icon}
                <Text weight={700} size={32}>{title}</Text>
            </Line>
        }
        <div className="modal-body">
            {children}
            {
                !!normalizedButtons && !!normalizedButtons.length &&
                <Line align={"stretch"} gap={12} className={cn('model-buttons',
                    'mobile-modal-buttons',
                    {'model-buttons--single': isSingleButton},
                    {"reversed": mobileReverse}
                )}>{normalizedButtons}</Line>
            }
        </div>
    </MStack>
}

export const ModalMobileTooltip = ({title, children}: { title: string, children: React.ReactNode }) => {
    return <MStack gap={8} align={'stretch'}>
        <Text color={'primary'} weight={700} size={20}>{title}</Text>
        <div className={'modal-mobile--body'}>
            {children}
        </div>
    </MStack>
}


export const ModalWindow: React.FC<{
    width?: number, children?: React.ReactNode, open?: boolean,
    className?: string,
    onCancel?: () => void
    maskClosable?: boolean;
    /** For a window with no way out but its own button: `closable={false}` drops the cross,
     *  `keyboard={false}` the Escape. `rootClassName` reaches the mask (a blur behind it). */
    closable?: boolean;
    keyboard?: boolean;
    rootClassName?: string;
}>
    = ({className="",width = 450, children, maskClosable=true, open, onCancel, ...props}) => {
    

    return <Modal classNames={{content: cn('modal-window', className)}} className={cn("modal-window--root")} open={open} onCancel={onCancel}
                  width={width + 48} centered title={null} footer={null} maskClosable={maskClosable} {...props}>
        {children}
    </Modal>
}
